import { ArrowRight } from "lucide-react";
import { Mascot } from "@/components/Mascot";
import { usePrefs } from "@/context/PrefsContext";

export function BatchBreak({ review, batchNo, batches, done, total, onContinue, loading }) {
  const { t, area } = usePrefs();
  if (loading || !review) {
    return <div className="mx-auto max-w-2xl py-16 text-center text-sm text-muted-foreground" data-testid="batch-break-loading">{t("loading")}</div>;
  }
  return (
    <div className="mx-auto max-w-2xl fade-up" data-testid="batch-break">
      <p className="text-xs uppercase tracking-wide text-muted-foreground" data-testid="batch-break-title">{t("batchDone").replace("{n}", batchNo).replace("{total}", batches)} · {done}/{total} {t("question").toLowerCase()}</p>
      <div className="soft-card mt-4 p-6 sm:p-8">
        <Mascot m={review.mascot} size={132} testid="batch-mascot" />
        <div className="mt-6 flex flex-wrap items-end gap-x-6 gap-y-2 border-t border-border pt-6">
          <div><span data-testid="batch-score" className="font-jpserif text-5xl leading-none">{review.score}</span><span className="text-lg text-muted-foreground"> / {review.total}</span></div>
          <div className="pb-1 text-sm text-muted-foreground"><span data-testid="batch-pct" className="font-semibold text-foreground">{review.pct}%</span> {t("correct").toLowerCase()} · {t("batchInterim")}</div>
        </div>
        <div className="mt-5 flex flex-wrap gap-2" data-testid="batch-breakdown">
          {review.breakdown.map((b) => <span key={b.area} data-testid={`batch-area-${b.area}`} className={`rounded-full px-2.5 py-1 text-xs ${b.pct < 70 ? "bg-primary/10 text-primary" : "bg-sage-soft text-sage"}`}>{area(b.area)} {b.correct}/{b.total}</span>)}
        </div>
      </div>
      <div className="mt-8 flex justify-end">
        <button data-testid="batch-continue-button" onClick={onContinue} className="inline-flex items-center gap-2 rounded-full bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground transition-transform hover:-translate-y-0.5">{t("batchContinue").replace("{n}", batchNo + 1)}<ArrowRight className="h-4 w-4" /></button>
      </div>
    </div>
  );
}
